import moment from "moment";
import "moment/locale/es";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
    mostraAlertaError,
    mostraAlertaOk
} from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";
import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantilla/Page";
import {
    ProductosListar,
    ProductosLotesEditar
} from "../../../configuracion/apiUrls";
import {
    regexCODE
} from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";

moment.locale("es");

const EditarLote = () => {
    const { token } = useContextUsuario();
    const { setListaProductos, ActualizarLista, listaInventariosTipos } = useContextEmpleado();
    const location = useLocation();
    const { datos, loteIdSeleccionado } = location.state || {};
    const navigate = useNavigate();

    const [formularioProducto, setFormularioProducto] = useState({
        id: null,
        nombre: "",
        codigo: "",
        estado: "Disponible",
        lotes: [],
    });

    const [errorCodigo, setErrorCodigo] = useState(false);
    const [errorNombre, setErrorNombre] = useState(false);
    const [erroresLote, setErroresLote] = useState({});
    const [erroresLotePrecio, setErroresLotePrecio] = useState({});
    const [erroresLoteInventario, setErroresLoteInventario] = useState({});

    useEffect(() => {
        if (datos && loteIdSeleccionado) {
            const loteParaEditar = datos.lotes.find(lote => lote.id === loteIdSeleccionado);

            if (loteParaEditar) {
                setFormularioProducto({
                    id: datos.id,
                    nombre: datos.nombre || "",
                    codigo: datos.codigo || "",
                    lotes: [{
                        ...loteParaEditar,
                        fecha_ingreso: loteParaEditar.fecha_ingreso ? moment(loteParaEditar.fecha_ingreso).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                        costo: loteParaEditar.costo || "",
                        precio: loteParaEditar.precio || "",
                        utilidad: loteParaEditar.utilidad || "",
                        cantidad: loteParaEditar.cantidad || "",
                        existencia: loteParaEditar.existencia || "",
                        estado: loteParaEditar.estado || "Disponible",
                        enPedido: loteParaEditar.enPedido || 0,
                        loteprecios: loteParaEditar.loteprecios && loteParaEditar.loteprecios.length > 0 ? loteParaEditar.loteprecios.map(lp => ({
                            id: lp.id,
                            cantidad: lp.cantidad || "",
                            precio: lp.precio || "",
                        })) : [],
                        loteinventarios: loteParaEditar.loteinventarios && loteParaEditar.loteinventarios.length > 0 ? loteParaEditar.loteinventarios.map(li => ({
                            id: li.id,
                            existencia: li.existencia || "",
                            estado: li.estado || "Activo",
                            inventarioTipoId: li.inventarioTipo.id || "",
                        })) : [],
                    }],
                });
            } else {
                mostraAlertaError("El lote seleccionado no fue encontrado.");
                navigate('/app/admin/lotes/nuevo');
            }
        } else if (datos) {
            setFormularioProducto({
                id: datos.id,
                nombre: datos.nombre || "",
                codigo: datos.codigo || "",
                lotes: datos.lotes && datos.lotes.length > 0 ? datos.lotes.map(lote => ({
                    ...lote,
                    fecha_ingreso: lote.fecha_ingreso ? moment(lote.fecha_ingreso).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                    costo: lote.costo || "",
                    precio: lote.precio || "",
                    utilidad: lote.utilidad || "",
                    cantidad: lote.cantidad || "",
                    existencia: lote.existencia || "",
                    estado: lote.estado || "Disponible",
                    enPedido: lote.enPedido || 0,
                    loteprecios: lote.loteprecios && lote.loteprecios.length > 0 ? lote.loteprecios.map(lp => ({
                        id: lp.id,
                        cantidad: lp.cantidad || "",
                        precio: lp.precio || "",
                    })) : [],
                    loteinventarios: lote.loteinventarios && lote.loteinventarios.length > 0 ? lote.loteinventarios.map(li => ({
                        id: li.id,
                        existencia: li.existencia || "",
                        estado: li.estado || "Activo",
                        inventarioTipoId: li.inventarioTipo.id || "",
                    })) : [],
                })) : [],
            });
        }
    }, [datos, loteIdSeleccionado, navigate]);


    const manejadorProducto = (e) => {
        const { name, value } = e.target;
        setFormularioProducto((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "codigo") {
            setErrorCodigo(!regexCODE.test(value) && value !== "");
        }
        if (name === "nombre") {
            setErrorNombre(value.length < 3 && value !== "");
        }
    };

    const manejadorLoteCampo = (e, index) => {
        const { name, value } = e.target;
        const newLotes = [...formularioProducto.lotes];
        newLotes[index] = {
            ...newLotes[index],
            [name]: value,
        };

        if (name === "cantidad" || name === "existencia") {
            newLotes[index].cantidad = value;
            newLotes[index].existencia = value;
        }

        if (name === "costo" || name === "precio") {
            const costo = parseFloat(newLotes[index].costo) || 0;
            const precio = parseFloat(newLotes[index].precio) || 0;
            newLotes[index].utilidad = (precio - costo).toFixed(2);
        }

        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));

        setErroresLote(prev => ({
            ...prev,
            [`${index}-${name}`]: ""
        }));
    };

    const agregarLote = () => {
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: [
                ...prev.lotes,
                {
                    nombre_lote: `Lote ${prev.lotes.length + 1}`,
                    fecha_ingreso: moment().format("YYYY-MM-DD"),
                    costo: "",
                    precio: "",
                    utilidad: "",
                    cantidad: "",
                    existencia: "",
                    estado: "Disponible",
                    enPedido: 0,
                    loteprecios: [],
                    loteinventarios: [],
                },
            ],
        }));
    };

    const eliminarLote = (index) => {
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: prev.lotes.filter((_, i) => i !== index),
        }));
        setErroresLote(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                const [loteIndex, field] = key.split('-');
                if (parseInt(loteIndex) === index) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
        setErroresLotePrecio(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                const [loteIndex, precioIndex, field] = key.split('-');
                if (parseInt(loteIndex) === index) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
        setErroresLoteInventario(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                const [loteIndex, inventarioIndex, field] = key.split('-');
                if (parseInt(loteIndex) === index) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
    };


    const agregarLotePrecio = (loteIndex) => {
        const newLotes = [...formularioProducto.lotes];
        newLotes[loteIndex] = {
            ...newLotes[loteIndex],
            loteprecios: [
                ...(newLotes[loteIndex].loteprecios || []),
                { cantidad: "", precio: "" },
            ],
        };
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
    };

    const eliminarLotePrecio = (loteIndex, precioIndex) => {
        const newLotes = [...formularioProducto.lotes];
        newLotes[loteIndex].loteprecios = newLotes[loteIndex].loteprecios.filter(
            (_, i) => i !== precioIndex
        );
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLotePrecio(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                const [loteIdx, precioIdx, field] = key.split('-');
                if (parseInt(loteIdx) === loteIndex && parseInt(precioIdx) === precioIndex) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
    };

    const handleLotePrecioChange = (loteIndex, precioIndex, name, value) => {
        const newLotes = [...formularioProducto.lotes];
        const newLoteprecios = [...newLotes[loteIndex].loteprecios];
        newLoteprecios[precioIndex] = {
            ...newLoteprecios[precioIndex],
            [name]: value,
        };
        newLotes[loteIndex].loteprecios = newLoteprecios;
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLotePrecio(prev => ({
            ...prev,
            [`${loteIndex}-${precioIndex}-${name}`]: ""
        }));
    };

    const agregarLoteInventario = (loteIndex) => {
        const newLotes = [...formularioProducto.lotes];
        newLotes[loteIndex] = {
            ...newLotes[loteIndex],
            loteinventarios: [
                ...(newLotes[loteIndex].loteinventarios || []),
                { existencia: 0, inventarioTipoId: "", estado: "Activo" },
            ],
        };
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
    };

    const eliminarLoteInventario = (loteIndex, inventarioIndex) => {
        const newLotes = [...formularioProducto.lotes];
        newLotes[loteIndex].loteinventarios = newLotes[loteIndex].loteinventarios.filter(
            (_, i) => i !== inventarioIndex
        );
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLoteInventario(prev => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach(key => {
                const [loteIdx, invIdx, field] = key.split('-');
                if (parseInt(loteIdx) === loteIndex && parseInt(invIdx) === inventarioIndex) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
    };

    const handleLoteInventarioChange = (loteIndex, inventarioIndex, name, value) => {
        const newLotes = [...formularioProducto.lotes];
        const newLoteinventarios = [...newLotes[loteIndex].loteinventarios];

        const finalValue = name === 'existencia' ? (value === "" ? "" : Number(value)) : value;

        newLoteinventarios[inventarioIndex] = {
            ...newLoteinventarios[inventarioIndex],
            [name]: finalValue,
        };
        newLotes[loteIndex].loteinventarios = newLoteinventarios;
        setFormularioProducto((prev) => ({
            ...prev,
            lotes: newLotes,
        }));
        setErroresLoteInventario(prev => ({
            ...prev,
            [`${loteIndex}-${inventarioIndex}-${name}`]: ""
        }));
    };

    const BotonGuardar = () => {
        const guardarProducto = async () => {
            let valid = true;
            const newErroresLote = {};
            const newErroresLotePrecio = {};
            const newErroresLoteInventario = {};

            formularioProducto.lotes.forEach((lote, loteIndex) => {
                if (!lote.nombre_lote) {
                    newErroresLote[`${loteIndex}-nombre_lote`] = "El nombre del lote es obligatorio.";
                    valid = false;
                } else if (typeof lote.nombre_lote !== 'string') {
                    newErroresLote[`${loteIndex}-nombre_lote`] = "El nombre del lote debe ser una cadena de texto.";
                    valid = false;
                } else if (lote.nombre_lote.length > 150) {
                    newErroresLote[`${loteIndex}-nombre_lote`] = "El nombre del lote no puede tener más de 150 caracteres.";
                    valid = false;
                }
                if (isNaN(parseFloat(lote.costo)) || parseFloat(lote.costo) <= 0) {
                    newErroresLote[`${loteIndex}-costo`] = "El costo es obligatorio y debe ser un número positivo.";
                    valid = false;
                }
                if (isNaN(parseFloat(lote.precio)) || parseFloat(lote.precio) <= 0) {
                    newErroresLote[`${loteIndex}-precio`] = "El precio es obligatorio y debe ser un número positivo.";
                    valid = false;
                }
                if (isNaN(parseFloat(lote.utilidad)) || parseFloat(lote.utilidad) < 0) {
                    newErroresLote[`${loteIndex}-utilidad`] = "La utilidad es obligatoria y debe ser un número positivo.";
                    valid = false;
                }
                const cantidad = parseInt(lote.cantidad);
                if (!Number.isInteger(cantidad) || cantidad < 0) {
                    newErroresLote[`${loteIndex}-cantidad`] = "La cantidad es obligatoria y debe ser un número entero positivo o cero.";
                    valid = false;
                }

                const existenciaTotal = parseInt(lote.existencia) || 0;
                if (!Number.isInteger(existenciaTotal) || existenciaTotal < 0) {
                    newErroresLote[`${loteIndex}-existencia`] = "La existencia es obligatoria y debe ser un número entero positivo o cero.";
                    valid = false;
                }

                lote.loteprecios.forEach((lp, precioIndex) => {
                    const cantidadPrecio = parseInt(lp.cantidad);
                    const precio = parseFloat(lp.precio);

                    if (!Number.isInteger(cantidadPrecio) || cantidadPrecio < 1) {
                        newErroresLotePrecio[`${loteIndex}-${precioIndex}-cantidad`] = "La cantidad es obligatoria y debe ser un número entero positivo.";
                        valid = false;
                    }
                    if (isNaN(precio) || precio <= 0) {
                        newErroresLotePrecio[`${loteIndex}-${precioIndex}-precio`] = "El precio es obligatorio y debe ser un número positivo.";
                        valid = false;
                    }
                });

                let totalAsignado = 0;

                lote.loteinventarios.forEach((li, inventarioIndex) => {
                    const existenciaAsignada = parseInt(li.existencia);

                    if (isNaN(existenciaAsignada) || existenciaAsignada < 0) {
                        newErroresLoteInventario[`${loteIndex}-${inventarioIndex}-existencia`] = "La existencia es obligatoria y debe ser un número entero positivo o cero.";
                        valid = false;
                    }

                    if (!li.inventarioTipoId) {
                        newErroresLoteInventario[`${loteIndex}-${inventarioIndex}-inventarioTipoId`] = "Seleccione un tipo de inventario.";
                        valid = false;
                    }

                    totalAsignado += existenciaAsignada;
                });

                if (totalAsignado > existenciaTotal) {
                    newErroresLote[`${loteIndex}-existenciaTotal`] = `La suma de las existencias asignadas (${totalAsignado}) no puede exceder la existencia total del lote (${existenciaTotal}).`;
                    valid = false;
                }

                if (newErroresLote[`${loteIndex}-existenciaTotal`]) {
                    newErroresLote[`${loteIndex}-existencia`] = newErroresLote[`${loteIndex}-existenciaTotal`];
                }

            });

            setErroresLote(newErroresLote);
            setErroresLotePrecio(newErroresLotePrecio);
            setErroresLoteInventario(newErroresLoteInventario);

            if (!valid) {
                mostraAlertaError("Por favor, corrige los errores en el formulario.");
                return;
            }

            const lotes = formularioProducto.lotes.map(lote => ({
                id: lote.id,
                nombre_lote: lote.nombre_lote,
                fecha_ingreso: lote.fecha_ingreso,
                costo: parseFloat(lote.costo),
                precio: parseFloat(lote.precio),
                utilidad: parseFloat(lote.utilidad),
                cantidad: parseInt(lote.cantidad),
                existencia: parseInt(lote.existencia),
                estado: lote.estado,
                enPedido: parseInt(lote.enPedido),
            }));

            const lotesPrecios = formularioProducto.lotes.flatMap(lote =>
                lote.loteprecios.map(lp => ({
                    id: lp.id,
                    cantidad: parseInt(lp.cantidad),
                    precio: parseFloat(lp.precio),
                    loteId: lote.id,
                }))
            );

            const lotesInventarios = formularioProducto.lotes.flatMap(lote =>
                lote.loteinventarios.map(li => ({
                    id: li.id,
                    existencia: parseInt(li.existencia),
                    inventarioTipoId: parseInt(li.inventarioTipoId),
                    estado: li.estado,
                    loteId: lote.id,
                }))
            );

            const productoPayload = {
                id: formularioProducto.id,
                nombre: formularioProducto.nombre,
                codigo: formularioProducto.codigo,
                estado: formularioProducto.estado,
                lotes: lotes,
                lotesPrecios: lotesPrecios,
                lotesInventario: lotesInventarios,
            };

            try {
                AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                await AxiosPrivado.put(`${ProductosLotesEditar}${formularioProducto.id}`, productoPayload);
                mostraAlertaOk("Lote actualizado correctamente");
                navigate('/app/admin/lotes/gestionar');
                ActualizarLista(ProductosListar, setListaProductos);
            } catch (error) {
                ErroresPeticion(error, mostraAlertaError);
            }
        };

        return (
            <button className="btn btn-warning" onClick={guardarProducto}>
                <i className="fas fa-save me-2 mx-2"></i>
                Guardar Cambios
            </button>
        );
    };

    const pageData = {
        titulo: {
            titulo: "Edición de Producto de lotes",
            url: "/app/admin/lotes/gestionar",
            tituloUrl: "Lotes",
            nombreUrl: "edición",
        },
    };

    return (
        <Page datos={pageData}>
            <Card pie={<BotonGuardar />}>
                <h5 className="mb-3 text-primary">Información general del producto</h5>
                <hr className="mb-4" />
                <div className="row g-4 mb-5 align-items-end">
                    <div className="col-12 col-lg-4">
                        <div className="form-group">
                            <label htmlFor="codigoProducto" className="form-label fw-bold text-muted small mb-1">CÓDIGO</label>
                            <input
                                type="text"
                                className="form-control"
                                id="codigoProducto"
                                name="codigo"
                                value={formularioProducto.codigo}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="form-group">
                            <label htmlFor="nombreProducto" className="form-label fw-bold text-muted small mb-1">NOMBRE DEL PRODUCTO</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nombreProducto"
                                name="nombre"
                                value={formularioProducto.nombre}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 d-flex align-items-center">
                        <div className="text-center p-3 w-100 bg-white border rounded shadow-sm d-flex align-items-center justify-content-center" style={{ height: '90px' }}>
                            {formularioProducto.codigo ? (
                                <Barcode
                                    value={formularioProducto.codigo}
                                    format="CODE128"
                                    width={2}
                                    height={50}
                                    displayValue={true}
                                />
                            ) : (
                                <p className="text-muted m-0 small">Código no disponible para generar código de barras.</p>
                            )}
                        </div>
                    </div>
                </div>
                <h5 className="mt-5 mb-3 text-primary">Gestión de Lotes</h5>
                <hr className="mb-4" />

                {formularioProducto.lotes.map((lote, loteIndex) => {
                    const existenciaTotal = parseInt(lote.existencia) || 0;
                    const totalAsignado = (lote.loteinventarios || []).reduce((sum, item) => sum + (parseInt(item.existencia) || 0), 0);
                    const existenciaDisponible = existenciaTotal - totalAsignado;

                    return (
                        <div key={loteIndex} className="card border-primary mb-4 shadow-sm">
                            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Detalles del Lote #{loteIndex + 1}</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`nombreLote-${loteIndex}`} className="form-label">Nombre</label>
                                            <input
                                                type="text"
                                                className={`form-control ${erroresLote[`${loteIndex}-nombre_lote`] ? "is-invalid" : ""}`}
                                                id={`nombreLote-${loteIndex}`}
                                                placeholder="Ej. Lote A1"
                                                name="nombre_lote"
                                                value={lote.nombre_lote}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-nombre_lote`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-nombre_lote`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`fechaIngresoLote-${loteIndex}`} className="form-label">Fecha de ingreso</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id={`fechaIngresoLote-${loteIndex}`}
                                                value={lote.fecha_ingreso}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`costoLote-${loteIndex}`} className="form-label">Costo</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control ${erroresLote[`${loteIndex}-costo`] ? "is-invalid" : ""}`}
                                                id={`costoLote-${loteIndex}`}
                                                placeholder="Costo total del lote"
                                                name="costo"
                                                value={lote.costo}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-costo`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-costo`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`precioLote-${loteIndex}`} className="form-label">Precio</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control ${erroresLote[`${loteIndex}-precio`] ? "is-invalid" : ""}`}
                                                id={`precioLote-${loteIndex}`}
                                                placeholder="Precio de venta del lote"
                                                name="precio"
                                                value={lote.precio}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-precio`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-precio`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`utilidadLote-${loteIndex}`} className="form-label">Utilidad</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                className={`form-control ${erroresLote[`${loteIndex}-utilidad`] ? "is-invalid" : ""}`}
                                                id={`utilidadLote-${loteIndex}`}
                                                placeholder="Utilidad calculada"
                                                name="utilidad"
                                                value={lote.utilidad}
                                                readOnly
                                            />
                                            {erroresLote[`${loteIndex}-utilidad`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-utilidad`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`cantidadLote-${loteIndex}`} className="form-label">Cantidad</label>
                                            <input
                                                type="number"
                                                step="1"
                                                className={`form-control ${erroresLote[`${loteIndex}-cantidad`] ? "is-invalid" : ""}`}
                                                id={`cantidadLote-${loteIndex}`}
                                                name="cantidad"
                                                value={lote.cantidad}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-cantidad`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-cantidad`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`existenciaLote-${loteIndex}`} className="form-label">Existencia</label>
                                            <input
                                                type="number"
                                                step="1"
                                                className={`form-control ${erroresLote[`${loteIndex}-existencia`] ? "is-invalid" : ""}`}
                                                id={`existenciaLote-${loteIndex}`}
                                                name="existencia"
                                                value={lote.existencia}
                                                onChange={(e) => manejadorLoteCampo(e, loteIndex)}
                                            />
                                            {erroresLote[`${loteIndex}-existencia`] && (
                                                <div className="invalid-feedback">{erroresLote[`${loteIndex}-existencia`]}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor={`estadoLote-${loteIndex}`} className="form-label">Estado</label>
                                            <div className="form-check form-switch mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={`estadoLoteSwitch-${loteIndex}`}
                                                    name="estado"
                                                    checked={lote.estado === "Disponible"}
                                                    onChange={(event) => {
                                                        const newLotes = [...formularioProducto.lotes];
                                                        newLotes[loteIndex] = {
                                                            ...newLotes[loteIndex],
                                                            estado: event.target.checked ? "Disponible" : "Agotado",
                                                        };
                                                        setFormularioProducto((prev) => ({
                                                            ...prev,
                                                            lotes: newLotes,
                                                        }));
                                                    }}
                                                />
                                                <label className="custom-control-label" htmlFor={`estadoLoteSwitch-${loteIndex}`}>
                                                    {lote.estado === "Disponible" ? "Disponible" : "Agotado"}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`enPedidoLote-${loteIndex}`} className="form-label">Cantidad en Pedido de lote</label>
                                            <input
                                                type="number"
                                                step="1"
                                                className="form-control"
                                                id={`enPedidoLote-${loteIndex}`}
                                                value={lote.enPedido}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>

                                <h5 className="mt-4 pb-2 border-bottom text-muted">
                                    <i className="fas fa-money-bill-wave me-2 mx-2"></i> Precios por mayoreo
                                </h5>
                                <button
                                    className={`btn btn-sm ${Object.keys(erroresLotePrecio).length > 0 ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                                    onClick={() => agregarLotePrecio(loteIndex)}
                                >
                                    <i className="fas fa-plus me-2"></i> Agregar nivel de precio
                                </button>
                                <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                                    <i className="fas fa-tags me-3 fa-lg text-muted"></i>
                                    <p className="mb-0">
                                        <strong>Niveles de precio por volumen definidos:</strong>&nbsp;
                                        <span className="badge bg-dark">
                                            {lote.loteprecios?.length || 0}
                                            &nbsp;niveles
                                        </span>
                                    </p>
                                </div>

                                {lote.loteprecios && lote.loteprecios.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm align-middle">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th style={{ width: '30%' }}>Cantidad Mínima</th>
                                                    <th style={{ width: '40%' }}>Precio por Unidad</th>
                                                    <th style={{ width: '15%' }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lote.loteprecios.map((item, precioIndex) => {
                                                    const cantidadInvalida = erroresLotePrecio[`${loteIndex}-${precioIndex}-cantidad`];
                                                    const precioInvalido = erroresLotePrecio[`${loteIndex}-${precioIndex}-precio`];

                                                    return (
                                                        <tr key={precioIndex} className={cantidadInvalida || precioInvalido ? 'table-warning' : ''}>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className={`form-control form-control-sm ${cantidadInvalida ? "is-invalid" : ""}`}
                                                                    min="1"
                                                                    value={item.cantidad}
                                                                    onChange={(e) =>
                                                                        handleLotePrecioChange(loteIndex, precioIndex, "cantidad", e.target.value)
                                                                    }
                                                                />
                                                                {cantidadInvalida && (
                                                                    <div className="invalid-feedback">
                                                                        {cantidadInvalida}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    className={`form-control form-control-sm ${precioInvalido ? "is-invalid" : ""}`}
                                                                    value={item.precio}
                                                                    onChange={(e) =>
                                                                        handleLotePrecioChange(loteIndex, precioIndex, "precio", e.target.value)
                                                                    }
                                                                />
                                                                {precioInvalido && (
                                                                    <div className="invalid-feedback">
                                                                        {precioInvalido}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light text-danger"
                                                                    onClick={() => eliminarLotePrecio(loteIndex, precioIndex)}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-light border text-muted">
                                        <i className="fas fa-info-circle me-2"></i>
                                        No hay precios por volumen definidos.
                                    </div>
                                )}


                                <h5 className="mt-4 pb-2 border-bottom text-muted">
                                    <i className="fas fa-boxes me-2 mx-2"></i> Asignación de inventario del lote
                                </h5>
                                <button
                                    className={`btn btn-sm ${Object.keys(erroresLoteInventario).length > 0 || existenciaDisponible < 0 ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                                    onClick={() => agregarLoteInventario(loteIndex)}
                                >
                                    <i className="fas fa-plus me-2"></i> Asignar ubicación
                                </button>

                                <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                                    <i className="fas fa-box-open me-3 fa-lg text-muted"></i>
                                    <p className="mb-0">
                                        <strong>Existencia total del lote disponible para asignación:</strong>&nbsp;
                                        <span className={`badge ${existenciaDisponible >= 0 ? 'bg-dark' : 'bg-danger'}`}>
                                            {existenciaDisponible}
                                            &nbsp;unidades
                                        </span>
                                    </p>
                                </div>
                                {(lote.loteinventarios || []).length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th style={{ width: '20%' }}>Unidades</th>
                                                    <th style={{ width: '40%' }}>Ubicación (Tipo de Inventario)</th>
                                                    <th style={{ width: '25%' }}>Estado</th>
                                                    <th style={{ width: '15%' }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(lote.loteinventarios || []).map((item, inventarioIndex) => {
                                                    const existenciaAsignada = parseInt(item.existencia) || 0;
                                                    const totalAsignadoPrevia = (lote.loteinventarios || []).filter((_, i) => i !== inventarioIndex).reduce((sum, i) => sum + (parseInt(i.existencia) || 0), 0);
                                                    const existenciaDisponiblePorFila = existenciaTotal - totalAsignadoPrevia;

                                                    const existenciaInvalida = erroresLoteInventario[`${loteIndex}-${inventarioIndex}-existencia`] || (existenciaAsignada > existenciaDisponiblePorFila);
                                                    const tipoInvalido = erroresLoteInventario[`${loteIndex}-${inventarioIndex}-inventarioTipoId`];

                                                    return (
                                                        <tr key={inventarioIndex} className={existenciaInvalida || tipoInvalido ? 'table-warning' : ''}>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className={`form-control form-control-sm ${existenciaInvalida ? "is-invalid" : ""}`}
                                                                    min="0"
                                                                    value={item.existencia}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "existencia", e.target.value)}
                                                                />
                                                                {existenciaInvalida && (
                                                                    <div className="invalid-feedback">
                                                                        {erroresLoteInventario[`${loteIndex}-${inventarioIndex}-existencia`] || "Cantidad inválida o excede el límite."}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className={`form-control form-control-sm ${tipoInvalido ? "is-invalid" : ""}`}
                                                                    value={item.inventarioTipoId}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "inventarioTipoId", e.target.value)}
                                                                >
                                                                    <option value="">Seleccione tipo</option>
                                                                    {listaInventariosTipos?.map((tipo) => (
                                                                        <option key={tipo.id} value={tipo.id}>
                                                                            {tipo.nombre}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {tipoInvalido && (
                                                                    <div className="invalid-feedback">{tipoInvalido}</div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className="form-control form-control-sm"
                                                                    value={item.estado}
                                                                    onChange={(e) => handleLoteInventarioChange(loteIndex, inventarioIndex, "estado", e.target.value)}
                                                                >
                                                                    <option value="Activo">Activo</option>
                                                                    <option value="Inactivo">Inactivo</option>
                                                                </select>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light text-danger"
                                                                    onClick={() => eliminarLoteInventario(loteIndex, inventarioIndex)}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-light border text-muted">
                                        <i className="fas fa-map-marker-alt me-2"></i>
                                        Asigne unidades del lote a ubicaciones específicas de inventario.
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Card>
        </Page>
    );
};

export default EditarLote;